<template>
	<a-modal
		class="g-pay-file-collection-edit-modal"
		:visible="visible"
		title="文档合集付费编辑"
		width="730px"
		:centered="true"
		:mask-closable="false"
		:destroy-on-close="true"
		@cancel="onCancel"
	>
		<div class="g-edit-modal__scroll">
			<a-form layout="vertical" class="g-pay-file-collection-edit-form">
				<div class="g-pay-file-collection-edit-form__row">
					<a-form-item label="标题" class="g-pay-file-collection-edit-form__col">
						<a-input v-model:value="form.title" placeholder="例如 商业计划书资料合集" />
					</a-form-item>
					<a-form-item label="现价" class="g-pay-file-collection-edit-form__col">
						<a-input v-model:value="form.price" placeholder="例如 9.90" />
					</a-form-item>
					
				</div>
				<div class="g-pay-file-collection-edit-form__row">
					<a-form-item label="免费预览份数" class="g-pay-file-collection-edit-form__col">
						<a-input-number
							v-model:value="form.freePreviewCount"
							:min="0"
							:precision="0"
							style="width: 100%;"
						/>
					</a-form-item>
					<a-form-item label="初始展示份数（设置0表示展开全部）" class="g-pay-file-collection-edit-form__col">
						<a-input-number
							v-model:value="form.initExpandCount"
							:min="0"
							:precision="0"
							placeholder="0 表示展开全部"
							style="width: 100%;"
						/>
					</a-form-item>
					
				</div>
				<div class="g-pay-file-collection-edit-form__row">
					<a-form-item label="按钮文字" class="g-pay-file-collection-edit-form__col">
						<a-input v-model:value="form.buttonText" placeholder="解锁全部文档"  />
					</a-form-item>
					<a-form-item label="按钮颜色" class="g-pay-file-collection-edit-form__col">
						<div class="g-pay-file-collection-edit-form__colors">
							<div class="g-pay-file-collection-edit-form__color-item">
								<ColorPicker v-model="form.buttonBg"  :swatchWidth ="29" :swatchHeight="29" />
								<a-input v-model:value="form.buttonBg" style="width: 295px;" />
							</div>
						</div>
					</a-form-item>
				</div>
			</a-form>

			<div class="g-pay-file-collection-edit">
				<div class="g-pay-file-collection-edit__toolbar">
					<span v-if="form.items.length" class="g-pay-file-collection-edit__hint">文件支持拖拽排序</span>
					<div class="g-pay-file-collection-edit__toolbar-main">
						<span class="g-pay-file-collection-edit__count">已上传 {{ uploadedItems.length }} 个文件</span>
						<span class="g-pay-file-collection-edit__continue-add" @click="onAddFiles">继续添加</span>
					</div>
				</div>

				<UploadProgressPanel
					v-if="showFullUploadPanel"
					:tasks="uploadTasks"
					:merge="uploadTasks.length > 1"
					variant="modal"
				/>

				<EditListSortGroup
					v-else
					ref="sortList"
					class="g-pay-file-collection-edit__list"
					@dragover="onSortDragOver"
				>
					<div
						v-for="(item, index) in form.items"
						:key="item.id"
						:data-sort-id="item.id"
						class="g-pay-file-collection-edit__item"
						:class="[
							{ 'is-uploading': isActiveUploadItem(item, index) },
							getEditListSortItemClass(dragId, item.id, dragOverId),
						]"
						:draggable="!item.uploading"
						@dragstart="onDragStart(item.id)"
						@dragend="onDragEnd"
					>
						<template v-if="isActiveUploadItem(item, index)">
							<UploadProgressPanel
								:tasks="uploadTasks"
								:merge="uploadTasks.length > 1"
								variant="row"
							/>
						</template>
						<template v-else>
							<div class="g-pay-file-collection-edit__icon" aria-hidden="true">
								<img
									class="g-pay-file-collection-edit__icon-img"
									:src="getItemIconUrl(item)"
									:alt="getItemMark(item)"
								/>
							</div>
							<div class="g-pay-file-collection-edit__info">
								<input
									v-model="item.title"
									type="text"
									class="g-pay-file-collection-edit__title-input"
									placeholder="文档标题"
								/>
								<div class="g-pay-file-collection-edit__meta">{{ getItemMeta(item) }}</div>
							</div>
							<div class="g-pay-file-collection-edit__actions">
								<span
									class="g-pay-file-collection-edit__action-btn mbm-iconfont mbm-tihuan3"
									title="更换"
									@click="onReplaceFile(index)"
								></span>
								<span
									class="g-pay-file-collection-edit__action-btn is-delete mbm-iconfont mbm-guanbi1"
									title="删除"
									@click="onDeleteFile(index)"
								></span>
							</div>
						</template>
					</div>
					<div v-if="!form.items.length && !isUploading" class="g-pay-file-collection-edit__empty">
						<a-button type="primary" size="large" @click="onAddFiles">上传文档文件</a-button>
						<div class="g-pay-file-collection-edit__empty-hint">支持 PDF / Word / PPT / Excel</div>
					</div>
				</EditListSortGroup>
			</div>
		</div>

		<template #footer>
			<a-button @click="onCancel">取消</a-button>
			<a-button type="primary" :disabled="!uploadedItems.length || isUploading" @click="onConfirm">确认</a-button>
		</template>

		<input
			ref="fileInput"
			type="file"
			multiple
			accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx"
			class="g-pay-file-collection-edit__file-input"
			@change="onFileChange"
		/>
		<input
			ref="replaceInput"
			type="file"
			accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx"
			class="g-pay-file-collection-edit__file-input"
			@change="onReplaceFileChange"
		/>
	</a-modal>
</template>

<script>
	import { v4 as uuidv4 } from 'uuid';
	import UploadProgressPanel from './UploadProgressPanel.vue';
	import ColorPicker from './ColorPicker.vue';
	import {
		filterValidLocalFileList,
		MAX_LOCAL_FILES,
		revokeLocalFileItem,
		revokeLocalFiles,
	} from '../utils/localFile.js';
	import {
		getPayFileCollectionDefaults,
		getPayFileCollectionFileIconUrl,
		getPayFileCollectionFileType,
		getPayFileCollectionItemMeta,
		normalizePayFileCollectionData,
	} from '../utils/payFileCollection.js';
	import EditListSortGroup from './EditListSortGroup.vue';
	import {
		getEditListSortItemClass,
		handleEditListSortDragEnd,
		handleEditListSortDragOver,
		handleEditListSortDragStart,
	} from '../utils/editListDragSort.js';
	import {
		createUploadTasks,
		updateUploadTaskProgress,
		uploadHeaderMediaFiles,
	} from '../utils/uploadHeaderMedia.js';

	export default {
		name: 'GPayFileCollectionEditModal',
		components: { EditListSortGroup, UploadProgressPanel, ColorPicker },
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Object,
				default: () => getPayFileCollectionDefaults(),
			},
		},
		emits: ['update:visible', 'confirm'],
		data() {
			return {
				form: getPayFileCollectionDefaults(),
				dragId: '',
				dragOverId: '',
				replaceIndex: -1,
				isUploading: false,
				uploadMode: 'initial',
				uploadTargetId: '',
				replaceUploadIndex: -1,
				uploadTasks: [],
			};
		},
		computed: {
			showFullUploadPanel() {
				return this.isUploading && this.uploadMode === 'initial';
			},
			uploadedItems() {
				return this.form.items.filter(item => !item.uploading);
			},
		},
		watch: {
			visible(value) {
				if (value) {
					this.initForm();
				}
			},
		},
		beforeUnmount() {
			revokeLocalFiles(this.form.items);
		},
		methods: {
			getEditListSortItemClass,
			initForm() {
				const source = normalizePayFileCollectionData(this.data);
				this.form = {
					...source,
					items: source.items.map(item => ({ ...item })),
				};
			},
			normalizeColor(value) {
				if (/^#[0-9a-fA-F]{6}$/.test(value || '')) return value;
				return '#285af9';
			},
			onColorInput(field, color) {
				this.form[field] = color;
			},
			getItemMark(item) {
				return getPayFileCollectionFileType(item.filename).mark;
			},
			getItemIconUrl(item) {
				return getPayFileCollectionFileIconUrl(item.filename);
			},
			getItemMeta(item) {
				return getPayFileCollectionItemMeta(item);
			},
			createUploadPlaceholder(files = []) {
				return {
					id: `pending-${uuidv4()}`,
					filename: files.length > 1 ? `${files[0].name} 等${files.length}个` : (files[0]?.name || ''),
					title: files[0]?.name?.replace(/\.[^.]+$/, '') || '',
					filesize: '',
					uploading: true,
					local: true,
				};
			},
			isActiveUploadItem(item, index) {
				if (!this.isUploading || item.uploading !== true) return false;
				if (this.uploadMode === 'append') {
					return item.id === this.uploadTargetId;
				}
				if (this.uploadMode === 'replace') {
					return index === this.replaceUploadIndex;
				}
				return false;
			},
			removeUploadPlaceholder() {
				const index = this.form.items.findIndex(item => item.id === this.uploadTargetId);
				if (index !== -1) {
					this.form.items.splice(index, 1);
				}
			},
			clearUploadState() {
				this.isUploading = false;
				this.uploadTasks = [];
				this.uploadMode = 'initial';
				this.uploadTargetId = '';
				this.replaceUploadIndex = -1;
			},
			async uploadFiles(files, { mode = 'append', replaceIndex = -1 } = {}) {
				this.isUploading = true;
				this.uploadMode = mode;
				this.uploadTasks = createUploadTasks(files);

				if (mode === 'append') {
					const placeholder = this.createUploadPlaceholder(files);
					this.uploadTargetId = placeholder.id;
					this.form.items.push(placeholder);
				} else if (mode === 'replace') {
					this.replaceUploadIndex = replaceIndex;
					this.form.items[replaceIndex].uploading = true;
				}

				try {
					const items = await uploadHeaderMediaFiles(this, {
						type: 'file',
						files,
						onProgress: payload => updateUploadTaskProgress(this.uploadTasks, payload),
					});
					const normalizedItems = items.map(item => ({
						...item,
						title: item.filename?.replace(/\.[^.]+$/, '') || '',
					}));
					if (mode === 'append') {
						this.removeUploadPlaceholder();
						this.form.items.push(...normalizedItems);
					} else if (mode === 'replace') {
						const old = this.form.items[replaceIndex];
						revokeLocalFileItem(old);
						this.form.items.splice(replaceIndex, 1, normalizedItems[0]);
					} else if (mode === 'initial') {
						this.form.items.push(...normalizedItems);
					}
				} catch (error) {
					if (mode === 'append') {
						this.removeUploadPlaceholder();
					} else if (mode === 'replace' && this.form.items[replaceIndex]) {
						this.form.items[replaceIndex].uploading = false;
					}
					this.$message?.error?.('上传失败');
				} finally {
					this.clearUploadState();
				}
			},
			appendFiles(files) {
				const remain = MAX_LOCAL_FILES - this.form.items.length;
				if (remain <= 0) return;
				const validFiles = filterValidLocalFileList(files, remain);
				if (!validFiles.length) return;
				const mode = this.form.items.length === 0 ? 'initial' : 'append';
				return this.uploadFiles(validFiles, { mode });
			},
			onAddFiles() {
				this.$refs.fileInput.value = '';
				this.$refs.fileInput.click();
			},
			onReplaceFile(index) {
				this.replaceIndex = index;
				this.$refs.replaceInput.value = '';
				this.$refs.replaceInput.click();
			},
			onDeleteFile(index) {
				const target = this.form.items[index];
				if (target?.uploading) return;
				const [removed] = this.form.items.splice(index, 1);
				revokeLocalFileItem(removed);
			},
			onFileChange(event) {
				const files = Array.from(event.target.files || []);
				this.appendFiles(files);
				event.target.value = '';
			},
			onReplaceFileChange(event) {
				const file = (event.target.files || [])[0];
				event.target.value = '';
				if (!file || this.replaceIndex < 0) return;
				const valid = filterValidLocalFileList([file], 1);
				if (!valid.length) return;
				const replaceIndex = this.replaceIndex;
				this.replaceIndex = -1;
				this.uploadFiles(valid, { mode: 'replace', replaceIndex });
			},
			onDragStart(id) {
				handleEditListSortDragStart(this, id);
			},
			onSortDragOver(event) {
				handleEditListSortDragOver(event, this.$refs.sortList, this);
			},
			onDragEnd() {
				handleEditListSortDragEnd(this, this.$refs.sortList, this.form.items, this);
			},
			onCancel() {
				this.$emit('update:visible', false);
			},
			onConfirm() {
				this.$emit('confirm', normalizePayFileCollectionData(this.form));
				this.$emit('update:visible', false);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../styles/edit-float-panel.less';

	.g-pay-file-collection-edit-form__row {
		display: flex;
		gap: 16px;
	}

	.g-pay-file-collection-edit-form__col {
		flex: 1;
		min-width: 0;
	}

	.g-pay-file-collection-edit-form__upload-col {
		::v-deep(.ant-form-item-label) {
			display: none;
		}
		::v-deep(.ant-form-item-control-wrapper) {
			width: auto;
		}
	}

	.g-pay-file-collection-edit-form__colors {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		width:100%;
	}

	.g-pay-file-collection-edit-form__color-item {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.g-pay-file-collection-edit-form__swatch {
		position: relative;
		width: 28px;
		height: 28px;
		border-radius: 4px;
		overflow: hidden;
		cursor: pointer;
	}

	.g-pay-file-collection-edit-form__color-input {
		position: absolute;
		inset: 0;
		opacity: 0;
		cursor: pointer;
	}

	.g-pay-file-collection-edit {
		margin-top: 8px;
	}

	.g-pay-file-collection-edit__toolbar {
		.edit-list-sort-toolbar-row();
		margin-bottom: 10px;
	}

	.g-pay-file-collection-edit__toolbar-main {
		.edit-list-sort-toolbar-main();
	}

	.g-pay-file-collection-edit__count {
		font-size: 13px;
		color: #666;
	}

	.g-pay-file-collection-edit__continue-add {
		font-size: 13px;
		color: #285af9;
		cursor: pointer;
		margin-left: 16px;

		&:hover {
			color: #1e4bd8;
		}
	}

	.g-pay-file-collection-edit__upload-btn {
		padding: 0;
		border: none;
		background: transparent;
		font-size: 13px;
		color: #285af9;
		cursor: pointer;
		outline: none;

		&:disabled {
			color: #bbb;
			cursor: not-allowed;
		}
	}

	.g-pay-file-collection-edit__list {
		display: flex;
		flex-direction: column;
		gap: 10px;
		max-height: 360px;
		overflow-y: auto;
		padding-right: 4px;
	}

	.g-pay-file-collection-edit__item {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 12px;
		border: 1px solid #f0f0f0;
		border-radius: 10px;
		background: #fff;
		box-sizing: border-box;

		&.is-uploading {
			padding: 0;
			border: none;
			background: transparent;
		}
	}

	.g-pay-file-collection-edit__icon {
		flex-shrink: 0;
		width: 40px;
		height: 40px;
		border-radius: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	.g-pay-file-collection-edit__icon-img {
		width: 40px;
		height: 40px;
		object-fit: contain;
	}

	.g-pay-file-collection-edit__info {
		flex: 1;
		min-width: 0;
	}

	.g-pay-file-collection-edit__title-input {
		width: 100%;
		padding: 0;
		border: none;
		background: transparent;
		font-size: 14px;
		font-weight: 600;
		color: #333;
		line-height: 1.4;
		outline: none;

		&::placeholder {
			color: #bbb;
			font-weight: normal;
		}
	}

	.g-pay-file-collection-edit__meta {
		margin-top: 4px;
		font-size: 12px;
		color: #999;
		line-height: 1.4;
	}

	.g-pay-file-collection-edit__actions {
		display: flex;
		gap: 6px;
		flex-shrink: 0;
	}

	.g-pay-file-collection-edit__action-btn {
		color: #999;
		font-size: 16px;
		cursor: pointer;
		margin-right: 10px;

		&:hover {
			color: #285af9;
		}

		&.is-delete {
			font-size: 14px;
		}
	}

	.g-pay-file-collection-edit__empty {
		padding: 48px 12px;
		text-align: center;
		background: #fafafa;
		border-radius: 8px;
	}

	.g-pay-file-collection-edit__empty-hint {
		margin-top: 12px;
		font-size: 13px;
		color: #999;
	}

	.g-pay-file-collection-edit__add-more {
		text-align: center;
		margin-top: 12px;
	}

	.g-pay-file-collection-edit__hint {
		.edit-list-sort-hint-text();
	}

	.g-pay-file-collection-edit__file-input {
		display: none;
	}
</style>

<style lang="less">
	@import '../styles/edit-float-panel.less';

	.g-pay-file-collection-edit-modal {
		.edit-modal-scroll();
	}
</style>
